import React, { FC, useEffect, useState } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Box, Modal } from '@mui/material';

import { modalActions } from '@contexts/common/ModalContext';

import Loader from '@components/common/Loader';

import { loader, styleBackdrop, styleClose, viewBox } from './styles';

enum EventType {
  Ready = 'ready',
}

const YOUTUBE_VIDEO_LINK =
  'https://www.youtube.com/embed/j-99QS5ou58?si=lIPnbSV5JS0vMyNG';

const YouTubePlayer: FC = () => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      let { data } = event;
      const expectedOrigin = 'https://www.youtube.com';

      if (typeof data === 'string') {
        data = JSON.parse(data);
      }

      const eventType = data.event;

      if (event.origin !== expectedOrigin) {
        setIsReady(true);
        return;
      }

      if (eventType === EventType.Ready) {
        setIsReady(true);
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <>
      {!isReady && (
        <Box sx={loader}>
          <Loader />
        </Box>
      )}
      <iframe
        width="622"
        height="330"
        src={YOUTUBE_VIDEO_LINK}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      />
    </>
  );
};

const VaultsVideoModal: FC = () => (
  <Modal open sx={styleBackdrop} onClose={modalActions.hide}>
    <>
      <button aria-label="close" onClick={modalActions?.hide}>
        <CloseIcon sx={styleClose} />
      </button>
      <Box sx={viewBox}>
        <YouTubePlayer />
      </Box>
    </>
  </Modal>
);

export default VaultsVideoModal;
